import { i18nMark } from 'lingui-react';

const messages = {
  SERVICE_REQUEST_WIZARD: i18nMark('Create Service Request'),
  wizardProgress: i18nMark('Step {step} of {total}'),
  wizardReview: i18nMark('Review'),
};

export default messages;



// WEBPACK FOOTER //
// ./components/WizardControllerHeader/messages.js